<template>
  <div class="apparate">
    <!-- <Navigation /> -->
    <div
      class="content-container mp-container"
      v-if="!modalState"
    >
        <div
          class="main"
        >
          <Plan />
        </div>
        <div
          class="aside-right"
        >
          <VideoList 
            
          />
        </div>
    </div>
    <Modal v-if="modalState" />
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
import Plan from '@/components/Plan'
import VideoList from '@/components/Video-list'
import Modal from '@/components/Modal'
// import Navigation from '@/components/Navigation'

export default {
  name: 'apparate',
  components: {
    Plan,
    VideoList,
    Modal,
    // Navigation
  },
  data () {
    return {

    }
  },
  methods: {
    
  },
  computed: {
    ...mapGetters({
      selectedVideo: 'getSelectedVideo',
      player: 'getPlayerStatus',
      pagesData: 'getPagesData',
      modalState: 'getModalState'
    })
  },
  created () {
    this.$store.state.selectedVideo = null
  }
}
</script>
<style lang="scss" scoped>
  @import '@/scss/custom.scss';
  .apparate {
    position: relative;
    padding-top: 6rem;
    min-height: 100vh;
    @media (max-width: $tabletL) {
      padding-top: 12rem;
    }
  }
  .main {
    margin: 2rem 6rem 2rem 4rem;
    max-width: 1000px;
    @media (max-width: $laptop) {
      margin: 1rem;
    }
  }
</style>